export default "__VITE_ASSET__BsMKG4xe__"